import { useEventCallback } from '@cian/react-utils';

import { useMemo } from 'react';
import { throttle } from 'throttle-debounce';

import { getIsBrowserBuild } from '@/packages/utils/isBuildType';

export function useResizeObserver(cb: VoidFunction, delay: number = 300): ResizeObserver | undefined {
  /**
   * @description
   * Помогает решить проблему "ResizeObserver loop completed with undelivered notifications"
   */
  const throttledCb = useEventCallback(
    throttle(delay, () => {
      requestAnimationFrame(cb);
    }),
  );

  return useMemo<ResizeObserver | undefined>(() => {
    if (getIsBrowserBuild()) {
      /**
       * @description проверять смысла нет, никакой логики мы тут не накручиваем, все в рамках ResizeObserver API
       */
      /* istanbul ignore next */
      return new ResizeObserver(() => {
        throttledCb();
      });
    }

    return;
  }, [throttledCb]);
}
